module.exports = __webpack_public_path__ + "static/media/search-black.12ec7f05.svg";